import _ from 'lodash';

import {createResourcesUpdatedReducer} from '../../../helpers/models/resourceHelpers';
import {CalendarEventModel} from '../../../models/api/calendarEventModel';
import {AppAction} from '../../appActions';
import {ResourceMap} from '../../appTypes';
import {DataGroupsActionsEnum} from '../dataGroupsActions';

/*
 * Reducer.
 */

const calendarEventsUpdatedReducer = createResourcesUpdatedReducer(
  'calendarEvents',
  (calendarEvent) => calendarEvent.uid,
  mergeCalendarEvent,
);

export function calendarEventsReducer(
  state: ResourceMap<CalendarEventModel>,
  action: AppAction,
): ResourceMap<CalendarEventModel> {
  switch (action.type) {
    // Data Group.
    case DataGroupsActionsEnum.DATA_UPDATED:
      return calendarEventsUpdatedReducer(state, action);

    default:
      return state;
  }
}

/*
 * Merger.
 */

function mergeCalendarEvent(
  existingCalendarEvent: CalendarEventModel | undefined,
  calendarEvent: CalendarEventModel,
): CalendarEventModel {
  if (!existingCalendarEvent) {
    return calendarEvent;
  }

  return {
    ...calendarEvent,
    calendarEventVersionUids: _(existingCalendarEvent.calendarEventVersionUids)
      .concat(calendarEvent.calendarEventVersionUids)
      .uniq()
      .value(),
  };
}
